package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant

/**
 * Represents an active digicode challenge sent to a specific player.
 */
@Serializable
data class ActiveDigicode(
    @SerialName("id")
    val id: String,

    @SerialName("table_id")
    val tableId: String,

    @SerialName("target_participant_id")
    val targetParticipantId: String,

    @SerialName("digit_count")
    val digitCount: Int,

    @SerialName("max_attempts")
    val maxAttempts: Int,

    @SerialName("time_limit_seconds")
    val timeLimitSeconds: Int?,

    @SerialName("show_attempts_to_player")
    val showAttemptsToPlayer: Boolean,

    @SerialName("sound_enabled")
    val soundEnabled: Boolean,

    @SerialName("solution")
    val solution: String,

    @SerialName("status")
    val status: DigicodeStatus,

    @SerialName("attempts")
    val attempts: List<DigicodeAttempt>,

    @SerialName("created_by")
    val createdBy: String,

    @SerialName("created_at")
    val createdAt: Instant
)
